import * as z from "zod/v4";

export const getIntelligentInventoryFileDownloadUrl = {
  name: "getIntelligentInventoryFileDownloadUrl" as const,
  input: z.object({ threadId: z.string(), s3Key: z.string() }),
  output: z.object({ downloadUrl: z.string() }),
};
